module.exports = __webpack_public_path__ + "static/media/zip-code.d585ea65.png";